import { isAfter as isAfterFns, isFuture as isFutureFns, isToday as isTodayFns, isTomorrow as isTomorrowFns, set as setFns, isBefore as isBeforeFns, parseISO as parseISOFns, intervalToDuration as intervalToDurationFns, add as addFns, sub as subFns } from 'date-fns';
/**
 * Checks if the given date is in the future.
 *
 * @param {Date} date - The date to check.
 * @returns {boolean} - Whether the date is in the future or not.
 */
export const isFuture = (date) => isFutureFns(date);
/**
 * Checks if the given date is today.
 *
 * @param {Date} date - The date to check.
 * @returns {boolean} - Whether the date is today or not.
 */
export const isToday = (date) => isTodayFns(date);
/**
 * Checks to see if a date is tomorrow.
 *
 * @param {Date} date - The date to check.
 * @returns {boolean} - Whether the date is tomorrow or not.
 */
export const isTomorrow = (date) => isTomorrowFns(date);
/**
 * Checks to see if the first date is after the second.
 *
 * @param {Date} date - The first date
 * @param {Date} dateToCompare - The date to compare with.
 * @returns {boolean} - Whether the date is after or not.
 */
export const isAfter = (date, dateToCompare) => isAfterFns(date, dateToCompare);
/**
 *
 * @param {Date} date - The date to update.
 * @param {SetValues} values - The values to set on the date.
 * @returns {Date} - the newly updated date.
 */
export const set = (date, values) => setFns(date, values);
/**
 * Compares two dates and indicates if the first date is before the second.
 *
 * @param {Date} date - The date to check.
 * @param {Date} dateToCompare - The date to compare with.
 * @returns {boolean} - Whether the date is in the future or not.
 */
export const isBefore = (date, dateToCompare) => isBeforeFns(date, dateToCompare);
/**
 * Parse the given string in ISO 8601 format and return a Date instance.
 *
 * @param {string} dateStringToBeParsed - String in ISO 8601 format to be parsed.
 * @returns {Date} - Date object parsed from string.
 */
export const parseISO = (dateStringToBeParsed) => parseISOFns(dateStringToBeParsed);
/**
 * Converts an interval object to a duration object.
 *
 * @param {Interval} dateInterval - Interval object to be converted. Of form {Date, Date}.
 * @returns {Duration} - Converted Interval object as Duration. Of form {years: X, ... , seconds: Y}.
 */
export const intervalToDuration = (dateInterval) => intervalToDurationFns(dateInterval);
/**
 * Takes a provided Date object and adds on a Duration object and returns the resulting date.
 *
 * @param {Date} date - Provided date that is to be updated.
 * @param {Duration} duration - Duration to be added on.
 * @returns {Date} - Updated date resulting from addition.
 */
export const add = (date, duration) => addFns(date, duration);
/**
 * Takes a provided Date object and subtracts a Duration object and returns the resulting date.
 *
 * @param {Date} date - Provided date that is to be updated.
 * @param {Duration} duration - Duration to be subtracted.
 * @returns {Date} - Updated date resulting from subtraction.
 */
export const sub = (date, duration) => subFns(date, duration);
//# sourceMappingURL=date-helpers.js.map